import { ButtonPrimary } from '../../../../utils/Button';

function InfoCard({ title, value }) {
    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm font-normal">{title || '--'}</h3>
                <div className="w-full text-primary text-base font-medium bg-transparent">
                    {value}
                </div>
            </div>
        </div>
    );
}

function InvoiceAuthorizationSetup({ data, setOpenModal }) {
    return (
        <div className="flex flex-row justify-between gap-5 bg-primary-50 rounded-md">
            <div className="flex flex-col gap-3 flex-1 ">
                <InfoCard title={data?.fullName || '------'} value={data?.email} />
            </div>
            <div className="flex justify-end items-center pr-2">
                <ButtonPrimary
                    title="Update Authorization"
                    onClick={() => setOpenModal('update_authorization')}
                />
            </div>
        </div>
    );
}

export default InvoiceAuthorizationSetup;
